import { render, staticRenderFns } from "./AddLog.vue?vue&type=template&id=0c6ccb78&scoped=true&"
import script from "./AddLog.vue?vue&type=script&lang=js&"
export * from "./AddLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ccb78",
  null
  
)

export default component.exports